import { useNavigate } from 'react-router-dom'
import { useHeaderState } from './useHeaderState'

export const useHeaderSearch = () => {
  const navigate = useNavigate()
  const { search, setSearchTerm, clearSearch } = useHeaderState()

  const handleSearchSubmit = e => {
    e.preventDefault()
    if (!search.searchTerm.trim()) return
    navigate(`/search?term=${encodeURIComponent(search.searchTerm)}`)
    clearSearch()
  }

  const handleSearchInput = e => {
    setSearchTerm(e.target.value)
  }

  const clearSearchTerm = () => {
    clearSearch()
  }

  return {
    // State
    searchTerm: search.searchTerm,

    // Functions
    handleSearchSubmit,
    handleSearchInput,
    clearSearch: clearSearchTerm,

    // Setters
    setSearchTerm
  }
}
